import React from "react";
var __jsx = React.createElement;
import BigNumber from 'bignumber.js';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdaterChainId } from "../../../../hooks";
import { timeFormat } from "./index";
import { formatUnits } from 'ethers/lib/utils';
import { getExplorerTransactionLink } from "../../../../utils/chain";
import { formatAmount } from "../../help";
import { StyledItemContainer, StyledItemRow, StyledDateLabel, StyledStatusText, StyledLabel, StyledValue, StyledIconLink } from "./styled";
import IconLink from "../../../../assets/images/link-rectangle-purple.svg";

var SuccessTradeItem = _ref => {
  var trade = _ref.trade,
      inputToken = _ref.inputToken,
      outputToken = _ref.outputToken;
  var createdAt = trade.createdAt,
      _trade$userTokenFille = trade.userTokenFilledAmount,
      userTokenFilledAmount = _trade$userTokenFille === void 0 ? '0' : _trade$userTokenFille,
      _trade$dealerTokenFil = trade.dealerTokenFilledAmount,
      dealerTokenFilledAmount = _trade$dealerTokenFil === void 0 ? '0' : _trade$dealerTokenFil,
      _trade$tokenlonFee = trade.tokenlonFee,
      tokenlonFee = _trade$tokenlonFee === void 0 ? '0' : _trade$tokenlonFee,
      _trade$dealerFee = trade.dealerFee,
      dealerFee = _trade$dealerFee === void 0 ? '0' : _trade$dealerFee,
      txId = trade.txId;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var expectChainId = useUpdaterChainId();
  var outputAmount = useMemo(() => {
    var amount = new BigNumber(dealerTokenFilledAmount).minus(dealerFee).minus(tokenlonFee).toString();
    return formatUnits(amount, outputToken === null || outputToken === void 0 ? void 0 : outputToken.decimals).toString();
  }, [dealerTokenFilledAmount, dealerFee, tokenlonFee]);
  var inputAmount = formatUnits(userTokenFilledAmount, inputToken === null || inputToken === void 0 ? void 0 : inputToken.decimals).toString();
  var tokenlonFeeAmount = formatUnits(tokenlonFee, outputToken === null || outputToken === void 0 ? void 0 : outputToken.decimals).toString();
  var targetRate = useMemo(() => {
    var dealerAmount = formatUnits(dealerTokenFilledAmount, outputToken === null || outputToken === void 0 ? void 0 : outputToken.decimals).toString();
    var result = new BigNumber(inputAmount).div(dealerAmount);
    return formatAmount(result);
  }, [inputAmount, outputAmount]);
  return __jsx(StyledItemContainer, null, __jsx(StyledItemRow, null, __jsx(StyledDateLabel, null, dayjs(createdAt).format(timeFormat)), __jsx(StyledStatusText, {
    color: "#4DBC9B"
  }, t('best_buy_trade_status_success'))), __jsx(StyledItemRow, null, __jsx(StyledLabel, null, t('order_detail_purchase_price', {
    token: outputToken.symbol
  })), __jsx(StyledValue, null, "".concat(targetRate, " ").concat(inputToken.symbol))), __jsx(StyledItemRow, null, __jsx(StyledLabel, null, t('order_detail_amount')), __jsx(StyledValue, null, "".concat(inputAmount, " ").concat(inputToken.symbol))), __jsx(StyledItemRow, null, __jsx(StyledLabel, null, t('order_detail_received', {
    token: outputToken.symbol
  })), __jsx(StyledValue, null, "".concat(outputAmount, " ").concat(outputToken.symbol))), __jsx(StyledItemRow, null, __jsx(StyledLabel, null, t('order_detail_fee')), __jsx(StyledValue, null, "".concat(formatAmount(tokenlonFeeAmount), " ").concat(outputToken.symbol))), __jsx(StyledItemRow, null, __jsx(StyledLabel, null, t('blockchain_explorer')), __jsx("a", {
    href: getExplorerTransactionLink(txId, expectChainId),
    target: "_blank"
  }, __jsx(StyledIconLink, {
    src: IconLink
  }))));
};

export default SuccessTradeItem;